import { Injectable } from '@angular/core';
import * as _ from 'lodash';
import * as color from '../../config/colors';
import * as background from '../../config/backgroundColor';
import * as legend from '../../config/legend';
import * as series from '../../config/series';
import * as toolbox from '../../config/toolbox'
import * as tooltip from '../../config/tootip'
import * as axisPointer from '../../config/axisPointer';
import * as xAxis from '../../config/xAxis'
import * as yAxis from '../../config/yAxis'
import * as grid from '../../config/grid';
import { CommonService } from '../../service/common.service';
import { EChartOption, ECharts } from 'echarts';
import { MultiDimensionBarComponent } from './multi-dimension-bar.component';
import { cloneDeep, isNil } from 'lodash';
import { ChartOptionService } from '../../service/chart-option.service'
import { axisLabelRotate } from './multi-dimension-bar-interface'




@Injectable({
  providedIn: 'root'
})
export class MultiDimensionBarService {

  constructor(
    private commonService: CommonService,
    private chartOptionService: ChartOptionService
  ) { }


  getChartxAxis() {
    let xAxisOption = this.chartOptionService.getChartxAxis(1);
    xAxisOption.forEach(e => {
      e['boundaryGap'] = true;
      e['axisTick']['show'] = false;
    })
    return xAxisOption;
  }

  // 小网格模式
  setSmallModeGrid(gridOption: EChartOption.Grid) {
    gridOption.top = grid.baseSmallPadding;
    gridOption.bottom = grid.baseSmallPadding;
    // gridOption.bottom = 100;
    gridOption.left = grid.baseSmallPadding;
    gridOption.right = grid.baseSmallPadding;
  }

  setSmallModePadding(component) {
    component.cardPadding = "0rem"
  }

  setXaxisName(xAxisOption: EChartOption.XAxis[], name: string) {
    xAxisOption.forEach(e => {
      e.name = name;
    })
  }

  setYaxisName(yAxisOption: EChartOption.YAxis[], name: string) {
    yAxisOption.forEach(e => {
      e.name = name;
    })
  }

  setYnameGap(yAxisOption: EChartOption.YAxis[], yNameGap: number) {
    yAxisOption.forEach(e => {
      e.nameGap = yNameGap
    })
  }

  setYAxisMinInterval(minInterval, yAxisOption: EChartOption.YAxis[]) {
    yAxisOption.forEach(e => {
      e.minInterval = minInterval;
    })
  }

  setLegendPosition(gridOption: EChartOption.Grid, legendOption, legendPosition: string) {
    let style = this.commonService.changeFontSize();
    switch (legendPosition) {
      case "top":
        legendOption.show = false;
        gridOption.bottom = style.noLegendGrid.bottom;
        break;
      case "right":

        gridOption.right = style.rightLegendGrid.right;

        gridOption.bottom = style.rightLegendGrid.bottom;
        // delete legendOption.width;
        legendOption['top'] = '14%';
        // legendOption['top'] = 0;
        legendOption['right'] = 0;
        legendOption['bottom'] = gridOption.bottom;
        legendOption['width'] = gridOption.right;
        legendOption['orient'] = "vertical";
        legendOption['pageIcons'] = {
          vertical: [
            "path://M472.064 272.448l-399.232 399.232c-22.08 22.08-22.08 57.792 0 79.872 22.016 22.016 57.792 22.08 79.872 0L512 392.256l359.296 359.296c22.016 22.016 57.792 22.08 79.872 0 22.08-22.08 22.016-57.792 0-79.872L551.936 272.448C529.856 250.432 494.144 250.432 472.064 272.448z",
            "path://M472.064 751.552 72.832 352.32c-22.08-22.08-22.08-57.792 0-79.872 22.016-22.016 57.792-22.08 79.872 0L512 631.744l359.296-359.296c22.016-22.016 57.792-22.08 79.872 0 22.08 22.08 22.016 57.792 0 79.872l-399.232 399.232C529.856 773.568 494.144 773.568 472.064 751.552z"
          ],
        };
        legendOption['textStyle']['padding'] = [2, 0, 0, 0];
        break;
      case "none":
        legendOption['show'] = false;
        gridOption.bottom = style.noLegendGrid.bottom;
      default:
        gridOption.bottom = legend.bottomLegendHeight;
        break;
    }
  }

  changeChartTitleDark(component: MultiDimensionBarComponent, darkMode: boolean) {
    if (darkMode) {
      component.chartTitleColor = color.darkModeTextColor;
      component.cardBgColor = background.darkModeBGColor;
    }
  }

  xAxisDarkMode(xAxisOption: EChartOption.XAxis[]) {
    xAxisOption.forEach(e => {
      if (isNil(e['axisLabel'])) {
        e['axisLabel'] = {};
      }
      e['axisLabel']['color'] = color.darkModeTextColor;
      if (isNil(e['nameTextStyle'])) {
        e['nameTextStyle'] = {};
      }
      e['nameTextStyle']['color'] = color.darkModeTextColor;
    });
  }

  yAxisDarkMode(yAxisOption: EChartOption.YAxis[]) {
    yAxisOption.forEach(e => {
      if (isNil(e['axisLabel'])) {
        e['axisLabel'] = {};
      }
      e['axisLabel']['color'] = color.darkModeTextColor;
      if (isNil(e['nameTextStyle'])) {
        e['nameTextStyle'] = {};
      }
      e['nameTextStyle']['color'] = color.darkModeTextColor;
      if (isNil(e['splitLine'])) {
        e['splitLine'] = {
          lineStyle: {
            color: color.darkModeTextColor
          }
        };
      } else {
        if (isNil(e['splitLine']['lineStyle'])) {
          e['splitLine']['lineStyle'] = {
            color: color.darkModeTextColor
          }
        } else {
          e['splitLine']['lineStyle']['color'] = color.darkModeTextColor;
        }
      }
    });
  }

  colorsDarkMode(colors: string[]) {
    colors.length = 0;
    color.darkModeColors.forEach(e => {
      colors.push(e);
    });
  }

  chartColorsChange(colors: string[], colorList: string[]) {
    colors.length = 0;
    colorList.forEach(e => {
      colors.push(e);
    });
  }

  legendDarkMode(legendOption) {
    if (isNil(legendOption['textStyle'])) {
      legendOption['textStyle'] = {
        color: color.darkModeTextColor
      };
    } else {
      legendOption['textStyle']['color'] = color.darkModeTextColor;
    }
  }

  seriesDarkMode(seriesOption: EChartOption.Series) {
    if (isNil(seriesOption['label'])) {
      seriesOption['label'] = {};
    }
    seriesOption['label']['color'] = color.darkModeTextColor;
  }

  chartBackgroundColorDarkMode(chartOption) {
    chartOption.backgroundColor = background.darkModeBGColor;
  }

  setInterval(option: any, interval: Number) {
    option.xAxis[0].axisLabel.interval = interval;
  }

  topLegendChange(legendDatas: any[], optionInit: ECharts) {
    legendDatas.forEach(e => {
      if (e.checked) {
        optionInit.dispatchAction({
          type: "legendSelect",
          name: e.value
        });
      } else {
        optionInit.dispatchAction({
          type: "legendUnSelect",
          name: e.value
        });
      }
    });
  }

  // 获取默认 柱状图系列
  getDefaultBarSeries() {
    let barSeries = this.chartOptionService.getDefaultBarSeries();
    barSeries.label.show = false;
    return barSeries;
  }
  // 构建series
  buildSeries(chartData: any, visualMapOption, seriesList: EChartOption.Series[], xAxisOption: EChartOption.XAxis[], barSeriesOption: EChartOption.Series) {
    seriesList.length = 0;

    if (chartData && chartData.hasOwnProperty('visualMap')) {
      if (chartData.visualMap.hasOwnProperty('type') && chartData.visualMap.hasOwnProperty('data')) {
        if (visualMapOption.type === chartData.visualMap.type) {
          visualMapOption.pieces = chartData.visualMap.data.pieces;
          visualMapOption.dimension = chartData.visualMap.data.dimension;
        } else {
          visualMapOption = this.chartOptionService.getContinuousVisualMap();
          visualMapOption.min = chartData.visualMap.data.min;
          visualMapOption.max = chartData.visualMap.data.max;
          visualMapOption.dimension = chartData.visualMap.data.dimension;
        }
      }
    }
    if (chartData && chartData.hasOwnProperty('data') && chartData.data.hasOwnProperty('seriesName')) {

      for (let i = 0; i < chartData.data.seriesName.length; i++) {
        let barSeries: EChartOption.Series = cloneDeep(barSeriesOption);
        barSeries['name'] = chartData.data.seriesName[i].name;
        barSeries['data'] = chartData.data.yData[i];

        if (chartData.data.hasOwnProperty('markLine') && chartData.data.markLine[i]) {
          barSeries['markLine']['data'] = chartData.data.markLine[i];
        }

        if (chartData.data.hasOwnProperty('markArea') && chartData.data.markArea[i]) {
          barSeries['markArea']['data'] = chartData.data.markArea[i];
        }

        seriesList.push(barSeries);
      }

    }
    xAxisOption.forEach(e => {
      e.data = chartData.data.xData;
    })
  }

  getAxisChartWithMultiDimensionTooltip() {
    let tooltipOption = this.chartOptionService.getAxisChartWithMultiDimensionTooltip();
    tooltipOption.axisPointer.type = 'shadow';
    tooltipOption.axisPointer.label.show = false;
    tooltipOption.enterable = false;
    return tooltipOption;
  }

  setSeriesDimensionName(barSeriesOption, dimensionNames, tooltipOption: EChartOption.Tooltip) {
    let name = [], units = [];
    if (_.isNil(dimensionNames)) {
      return
    }

    for (const iterator of dimensionNames) {
      name.push(iterator.dimensionName)
      units.push(iterator.unit)
    }
    let originDimensionNames = ['x'];
    originDimensionNames = originDimensionNames.concat(name)

    barSeriesOption.dimensions = originDimensionNames;

    tooltipOption.formatter = this.chartOptionService.getAxisChartWithMultiDimensionTooltip(units).formatter;
  }

  // 获取分段visualMap
  getPiecewiseVisualMap() {
    let visualMap = this.chartOptionService.getPiecewiseVisualMap();
    visualMap.show = false;
    return visualMap;
  }

  setYAxisMin(yAxisMin: number, yAxisOption: EChartOption.YAxis[]) {
    yAxisOption.forEach(e => {
      e.min = yAxisMin
    })
  }

  setYAxisMax(yAxisMax: number, yAxisOption: EChartOption.YAxis[]) {
    yAxisOption.forEach(e => {
      e.max = yAxisMax
    })
  }

  setYAxisInterval(yAxisInterval: number, yAxisOption: EChartOption.YAxis[]) {
    yAxisOption.forEach(e => {
      e.interval = yAxisInterval;
    })
  }

  setSeriesBackgroundShow(show: boolean, barSeriesOption) {
    barSeriesOption.showBackground = show;
  }

  // x轴label的旋转
  changeXAxisLabelRotate(chartOpt, xAxisLabelRotate: axisLabelRotate) {
    let rotate = 0;
    switch (xAxisLabelRotate) {
      case 'leftSmallAngle':
        rotate = 30
        break;
      case 'leftBigAngle':
        rotate = 60
        break;
      case 'rightSmallAngle':
        rotate = -30
        break;
      case 'rightBigAngle':
        rotate = -60
        break
    }
    chartOpt.xAxis[0].axisLabel.rotate = rotate;
    chartOpt.xAxis[0].axisLabel.formatter = (value: string): string => {
      let valueText = '';
      if (value.length > 5) {
        valueText = value.substring(0, 5) + '...'
      } else {
        valueText = value
      }
      return valueText;
    }
  }
  // y轴label的旋转
  changeYAxisLabelRotate(chartOpt, yAxisLabelRotate: axisLabelRotate) {
    let rotate = 0;
    switch (yAxisLabelRotate) {
      case 'leftSmallAngle':
        rotate = 30
        break;
      case 'leftBigAngle':
        rotate = 60
        break;
      case 'rightSmallAngle':
        rotate = -30
        break;
      case 'rightBigAngle':
        rotate = -60
        break
    }
    chartOpt.yAxis[0].axisLabel.rotate = rotate;
    // chartOpt.yAxis[0].axisLabel.formatter = (value: string): string => {
    //   let valueText = '';
    //   if (value.length > 5) {
    //     valueText = value.substring(0, 5) + '...'
    //   } else {
    //     valueText = value
    //   }
    //   return valueText;
    // }
  }
}
